<template>
	<div class="m head clearfix">
		<i class="icons logo"></i>
		<div class="search_wrap">
			<input type="text" name="搜索产品"  @keyup.enter='search' v-model='keyword'>
			<i class="icons search" @click='search'></i>
		</div>
	</div>
</template>
<script>
	export default {
	  name: 'head',
	  data(){
	  	return{
	  		showmenu:false,
	  		keyword:''
	  	}
	  },
	  mounted:function(){
	  	
	  },
	  methods:{
	  	search:function(){
	  		if(!this.keyword){
	  			alertMessage('搜索内容不能为空')
	  			return false;
	  		}
	  		this.$router.push('/m/search/'+this.keyword)
	  	}
	  }
	  
	}
</script>
<style scoped>
	.m.head{
		text-align: center;
		padding: 0.58rem 0 0.28rem;
		width: 100%;
		/* width: 6.4rem;
		margin: 0 auto; */
	}
	.m.head .icons{
		display: inline-block;
		background-image: url(/static/images/m/m_icons.png);
		background-size:2.77rem 1.9rem; 
	}
	.m.head .icons.logo{
		width: 1.49rem; height: 0.57rem;
    	background-position: -0.1rem -0.1rem;
    	margin-bottom: 0.32rem;
	}
	.search_wrap{
		padding:0 0.2rem;
		position: relative;
	}
	.search_wrap input{
		width: 6rem;
		height: 0.7rem;
		background-color: #f9f9f9;
		padding: 0 0.8rem 0 0.1rem;
		box-sizing: border-box;
		display: block;
	}
	.search_wrap .search{
		width: 0.31rem;
		height: 0.3rem;
		background-position: -2.35rem -1.21rem;
		position: absolute;
		right: 0.52rem;
		top: 50%;
		transform: translateY(-50%);
	}
</style>


// WEBPACK FOOTER //
// src/components/mobile/public/head.vue